import http from '../../../app//services/httpServices';
import URL_UTILITY from '../../../app/utility/url.utility';
const getIsdRevenueData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getIsdRevenueDataUrl + '/gst-isd-hdr',
    payload
  );
};
const postIsdRevenueData = (context, payload) => {
  return http.postApi(
    URL_UTILITY.getIsdRevenueDataUrl + '/isd-revenue/upsert',
    payload
  );
};
const getIsdRevenueDataById = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getIsdRevenueDataUrl + '/gst-isd-dtl',
    payload
  );
};
const getIsdCreditData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getIsdRevenueDataUrl + `/isd-tax-summary`,
    payload
  );
};
const getIsdCreditDistributionData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getIsdRevenueDataUrl + `/isd-dist-summary`,
    payload
  );
};
const getIsdHeaderData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getIsdRevenueDataUrl + `/isd-agg-hdr`,
    payload
  );
};
const getIsdCreditLineData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getIsdRevenueDataUrl + `/isd-agg-line`,
    payload
  );
};
const postExcludeCreditLineData = (context, payload) => {
  return http.putApi(
    URL_UTILITY.getIsdRevenueDataUrl + `/isd-agg-line/exclude`,
    payload
  );
};
const getIsdCreditDistributionDetails = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getIsdRevenueDataUrl + `/isd-dist-dtl`,
    payload
  );
};
const postfreezeIsdData = (context, payload) => {
  return http.putApi(
    URL_UTILITY.getIsdRevenueDataUrl + `/isd-agg-hdr/freeze`,
    payload
  );
};
const getIsdUnReconcileData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getIsdRevenueDataUrl + `/gstr2-unrec-summary`,
    payload
  );
};
const getReconcileDataPeriodWise = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getIsdRevenueDataUrl + `/gstr2-unrec-details`,
    payload
  );
};

export default {
  getIsdRevenueData,
  postIsdRevenueData,
  getIsdRevenueDataById,
  getIsdCreditData,
  getIsdCreditDistributionData,
  getIsdHeaderData,
  getIsdCreditLineData,
  postExcludeCreditLineData,
  getIsdCreditDistributionDetails,
  postfreezeIsdData,
  getIsdUnReconcileData,
  getReconcileDataPeriodWise
};
